import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08695e18"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 1,
  class: "NewButton__icon icon--left"
}
const _hoisted_3 = {
  key: 2,
  class: "fas fa-spinner animate-spin"
}
const _hoisted_4 = {
  key: 4,
  class: "NewButton__icon icon--right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "NewButton",
    ref: "elementref",
    type: _ctx.type,
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitClick && _ctx.emitClick(...args)), ["stop"]))
  }, [
    (_ctx.$slots['popup'] && _ctx.state.is_popup_opened)
      ? _renderSlot(_ctx.$slots, "popup", { key: 0 }, undefined, true)
      : _createCommentVNode("", true),
    (_ctx.$slots['icon-left'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon-left", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("i", _hoisted_3))
      : _renderSlot(_ctx.$slots, "default", { key: 3 }, undefined, true),
    (_ctx.$slots['icon-right'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "icon-right", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}